import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import {NoOrder} from './NoOrder';

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
  }),
)(NoOrder);
